import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';
import { SelectFilesButton } from './SelectFilesButton';
import '../styles/_fileDropZone.scss';

interface DropPanelProps {
    /** Receives the panel, which FileUploader takes drops on (its dropZone). */
    dropZoneRef: (element: HTMLDivElement | null) => void;
    /** Receives the Select Files button's wrapper (see SelectFilesButton). */
    selectButtonRef: (element: HTMLDivElement | null) => void;
    /** Highlights the panel while files are dragged over it. */
    isDraggingOver: boolean;
}

/** The panel files are dropped on: an upload icon, "Drag and drop files here, or" and Select Files. */
export const DropPanel = ({ dropZoneRef, selectButtonRef, isDraggingOver }: DropPanelProps) => {
    return (
        <div
            ref={dropZoneRef}
            className={`fileDropZone-panel${isDraggingOver ? ' dragging' : ''}`}
        >
            <FontAwesomeIcon
                icon={faCloudArrowUp}
                size='2x'
                className='fileDropZone-icon'
            />
            <div className='fileDropZone-hint'>Drag and drop files here, or</div>
            <SelectFilesButton triggerRef={selectButtonRef} />
        </div>
    );
};
